import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "Index",
    component: () => import("@/components/index"),
    children: [
      {
        path: "/pcStuCenter",
        name: "PcStuCenter",
        component: () => import("@/components/homePc/pcStuCenter")
      },
      {
        path: "/pcTchCenter",
        name: "PcTchCenter",
        component: () => import("@/components/homePc/pcTchCenter")
      },
      {
        path: "/pcComCenter",
        name: "PcComCenter",
        component: () => import("@/components/homePc/pcComCenter")
      },
      {
        path: "/pcIframe",
        name: "pcIframe",
        component: () => import("@/components/homePc/pcIframe")
      },
      {
        path: "/pcDownload",
        name: "PcDownload",
        component: () => import("@/components/homePc/pcDownload") // 网站备案 homePc => beian
      },
      {
        path: "/classrooom",
        name: "Classrooom",
        component: () => import("@/components/homePc/classrooom") // 网站备案 homePc => beian
      },
      {
        path: "/resource", // 套题资源
        name: "Resource",
        component: () => import("@/components/homePc/resource")
      },
      // {
      //   path: "/pptDownload",
      //   name: "pptDownload",
      //   component: () => import("@/components/teacher/second/ppt")
      // },
      {
        path: "/classroomRandom",
        name: "classroomRandom",
        component: () => import("@/components/teacher/second/classroomRandom")
      },
      {
        path: "/pcNotice",
        name: "PcNotice",
        component: () => import("@/components/homePc/pcNotice")
      },
      {
        path: "/pcReport",
        name: "PcReport",
        component: () => import("@/components/homePc/pcReport")
      },
      {
        path: "/pcNews",
        name: "PcNews",
        component: () => import("@/components/homePc/pcNews") // 网站备案 homePc => beian
      },
      {
        path: "/pcNews/detail",
        name: "PcNewsDetail",
        component: () => import("@/components/beian/details") // 网站备案 删除该路由
      },
      {
        path: "/pcNewsDetal",
        name: "PcNewsDetail",
        component: () => import("@/components/homePc/pcNewsDetail")
      },
      {
        path: "/pcNoticeDetail",
        name: "PcNoticeDetail",
        component: () => import("@/components/homePc/pcNoticeDetail")
      },
      {
        path: "/stu/user/version", // 学生支付完成后跳转页
        name: "payTemp",
        component: () => import("@/components/homePc/payTemp")
      },
      {
        path: "/phoneStuCenter",
        name: "phoneStuCenter",
        component: () => import("@/components/homePhone/phoneStuCenter")
      },
      {
        path: "/phoneTchCenter",
        name: "phoneTchCenter",
        component: () => import("@/components/homePhone/phoneTchCenter")
      },
      {
        path: "/phoneComCenter",
        name: "phoneComCenter",
        component: () => import("@/components/homePhone/phoneComCenter")
      },
      {
        path: "/phoneDownload",
        name: "phoneDownload",
        component: () => import("@/components/homePhone/phoneDownload")
      },
      {
        path: "/phoneNotice",
        name: "phoneNotice",
        component: () => import("@/components/homePhone/phoneNotice")
      },
      {
        path: "/phoneNews",
        name: "phoneNews",
        component: () => import("@/components/homePhone/phoneNews")
      },
      {
        path: "/phoneNewsDetail",
        name: "phoneNewsDetail",
        component: () => import("@/components/homePhone/phoneNewsDetail")
      },
      {
        path: "/phoneNoticeDetail",
        name: "phoneNoticeDetail",
        component: () => import("@/components/homePhone/phoneNoticeDetail")
      },
      {
        path: "/login_register",
        name: "login_register",
        component: () => import("@/components/login_register/login_register"),
        children: [
          {
            path: "/login_register/login",
            name: "login",
            component: () => import("@/components/login_register/login")
          },
          {
            path: "/login_register/register",
            name: "register",
            component: () => import("@/components/login_register/register")
          },
          {
            path: "/login_register/forget",
            name: "forget",
            component: () => import("@/components/login_register/forget")
          }
        ]
      }
    ]
  },
  {
    path: "/resource/list", // 套题资源
    name: "ResourceList",
    component: () => import("@/components/homePc/resourcelist")
  },
  {
    path: "/resource/paper", // 套题资源
    name: "ResourcePaper",
    component: () => import("@/components/homePc/paper")
  },
  {
    path: "*",
    component: () => import("@/components/public/404")
  },
  {
    path: "/addclass",
    name: "addClass",
    component: () => import("@/components/teacher/addClass")
  },
  {
    path: "/outlink",
    name: "outlink",
    component: () => import("@/components/outlink/index")
  },
  {
    path: "/home",
    component: () => import("@/components/teacher/TeacherHome"),
    children: [
      {
        path: "/",
        redirect: "/homeNew",
        name: "HomePage",
        component: () => import("@/components/teacher/second/HomePage"),
        children: [
          {
            path: "/homeNew", // 新首页
            name: "homeNew",
            components: {
              one: () => import("@/components/teacher/second/CheckUp"),
              two: () => import("@/components/teacher/second/Class"),
              three: () => import("@/components/teacher/second/video")
            }
          }
        ]
      },
      {
        path: "/video",
        name: "Video",
        component: () => import("@/components/teacher/second/video")
      },
      {
        path: "/assignwork", // 布置作业
        name: "AssignWork",
        component: () => import("@/components/teacher/second/AssignWork")
      },
      {
        path: "/checkup", // 检查作业列表
        name: "CheckUp",
        component: () => import("@/components/teacher/second/CheckUp")
      },
      {
        path: "/class",
        name: "Class",
        component: () => import("@/components/teacher/second/Class")
      },
      {
        path: "/classdetails",
        name: "ClassDetails",
        component: () => import("@/components/teacher/second/ClassDetails")
      },
      {
        path: "/historyrecord",
        name: "Historyrecord",
        component: () => import("@/components/teacher/second/Historyrecord")
      },
      {
        path: "/teach",
        name: "Teach",
        component: () => import("@/components/teacher/second/Teach")
      },
      {
        path: "/ppt",
        name: "ppt",
        component: () => import("@/components/teacher/second/ppt")
      },
      {
        path: "/user",
        component: () => import("@/components/teacher/second/User"),
        children: [
          {
            path: "/",
            component: () => import("@/components/teacher/second/UserInfo")
          },
          {
            path: "/user/password",
            component: () => import("@/components/teacher/second/Password")
          },
          {
            path: "/user/feedback",
            component: () => import("@/components/teacher/second/FeedBack")
          }
        ]
      },
      {
        path: "/details", //单个作业详情
        name: "StudentsDetails",
        component: () => import("@/components/teacher/second/StudentsDetails")
      },
      {
        path: "/wordscore/:score_id",
        name: "WordScore",
        component: () => import("@/components/teacher/second/WordScore")
      },
      {
        path: "/paperscore/:score_id",
        name: "PaperScore",
        component: () => import("@/components/teacher/second/PaperScore")
      },
      {
        path: "/followscore",
        name: "FollowupScore",
        component: () => import("@/components/teacher/second/FollowupScore")
      },
      {
        path: "/symbolscore",
        name: "SymbolScore",
        component: () => import("@/components/teacher/second/SymbolScore")
      },
      {
        path: "/dubbingscore",
        name: "DubbingScore",
        component: () => import("@/components/teacher/second/DubbingScore")
      },
      {
        path: "/wrong",
        name: "wrong",
        component: () => import("@/components/teacher/second/ErrorSubject")
      },
      {
        path: "/redorecord",
        name: "redorecord",
        component: () => import("@/components/teacher/second/Redorecord")
      },
      {
        path: "/wrongdetails",
        name: "wrongdetails",
        component: () => import("@/components/teacher/second/WrongDetail")
      }
    ]
  },
  {
    path: "/sales",
    name: "SalesLoad",
    component: () => import("@/components/sales/SalesLoad")
  },
  {
    path: "/sales/home",
    name: "SalesHome",
    component: () => import("@/components/sales/SalesHome")
  },
  {
    path: "/user/log",
    name: "LOG",
    component: () => import("@/components/log/LOG")
  },
  {
    path: "/datamanage/login",
    name: "DatamanageLogin",
    component: () => import("@/components/datamanage/login")
  },
  {
    path: "/datamanage",
    name: "DatamanageIndex",
    component: () => import("@/components/datamanage/index"),
    children: [
      {
        path: "createTopic",
        component: () => import("@/components/datamanage/createTopic")
      },
      {
        path: "createContent",
        component: () => import("@/components/datamanage/createContent")
      },
      {
        path: "search",
        component: () => import("@/components/datamanage/search")
      },
      {
        path: "",
        redirect: "createContent"
      }
    ]
  }
];

export default new Router({
  // mode:"history",
  routes
});



// WEBPACK FOOTER //
// ./src/router/index.js